module.exports = __webpack_public_path__ + "media/application/images/2018/2018-list-tick-dbda1648c0ff04a9edaa27950ce39720.svg";